import { FormattedMessage } from 'react-intl';
import { DropdownItem, ContextMenu } from 'src/componentes/dropdown';

import Ishikawa from 'src/paginas/widget-custom/ishikawa';
import EditIshikawa from 'src/paginas/widget-custom/ishikawa/edit';
import ContentManager from 'src/componentes/content-manager';
import LucideIcon from 'src/componentes/lucide-icon';
import useAuth from 'src/hooks/useAuth';

const AnaliseCausa = ({ model, handleChangeData, allowEdit }) => {
  const { terms: resources } = useAuth();

  const handleSave = (dadosIshikawa, index) => {
    let newModel = Object.assign([], model.analiseCausasModel);
    let itemCorrente = newModel[index];

    if (itemCorrente) {
      itemCorrente.componente.dadosIshikawa = dadosIshikawa;
    }

    newModel[index] = itemCorrente;
    handleChangeData &&
      handleChangeData('step2Data', 'analiseCausasModel', newModel);

    handleChangeData && handleChangeData('step2Data', 'alterado', true);
  };

  const handleEditWidget = (widget) => {
    ContentManager.addContent(
      <EditIshikawa
        widget={widget}
        showPropertiesStyle={false}
        handleSave={handleSave}
      />
    );
  };

  const renderComponent = (widget) => {
    return (
      <div>
        <ContextMenu
          disabled={!allowEdit}
          content={
            <DropdownItem onClick={() => handleEditWidget(widget)}>
              <LucideIcon icon="pencil" />
              {
                <FormattedMessage
                  id="label.editar"
                  values={{ editar: resources.editar }}
                />
              }
            </DropdownItem>
          }
        >
          <div
            id={'widget' + widget.item.id}
            onMouseDown={(e) => e.preventDefault()}
            onContextMenu={allowEdit ? undefined : (e) => e.preventDefault()}
          >
            {<Ishikawa widget={widget} showStar={false} />}
          </div>
        </ContextMenu>
      </div>
    );
  };

  return (
    <div
      className="position-relative w-100 p-1"
      style={{
        minHeight:
          model &&
          model.analiseCausasModel &&
          model.analiseCausasModel.length > 0
            ? model.analiseCausasModel.length * 600 + 10
            : 600,
        marginTop: '15px',
      }}
    >
      {model &&
        model.analiseCausasModel &&
        model.analiseCausasModel.length > 0 &&
        model.analiseCausasModel.map((item, index) => (
          <div
            style={{
              position: 'absolute',
              zIndex: item.zIndex,
              marginTop: item.y,
            }}
          >
            <div>{renderComponent({ item: item, index: index })}</div>
          </div>
        ))}
    </div>
  );
};

export default AnaliseCausa;
